import { render, staticRenderFns } from "./KindsDialog.vue?vue&type=template&id=5343820f&"
import script from "./KindsDialog.vue?vue&type=script&lang=js&"
export * from "./KindsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports